import { useEffect, useState } from 'react'

type UserAgentType = 'ios' | 'android' | 'others'

export const useUserAgent: () => UserAgentType | undefined = () => {
  const [userAgent, setUserAgent] = useState<UserAgentType>()

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera
    if (/android/i.test(ua)) {
      setUserAgent('android')
      return
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    ) {
      setUserAgent('ios')
      return
    }

    setUserAgent('others')
  }, [])

  return userAgent
}
